module.exports = __webpack_public_path__ + "static/media/No data.e6f398a9.gif";